import trueSound from '../../../sounds/true_01.mp3';
import falseSound from '../../../sounds/false_01.mp3';

export const gameConfig = {
  timing: {
    timeCapMax: 30,
    timePerWord: 1,    // Множник: скільки секунд дається на кожне слово
    feedbackDelay: 600, // тривалість спалаху (мс)
    tickInterval: 1000
  },

  scoring: {
    pointsPerCorrect: 1,
    penaltyPoints: 1,
    streakBonusMap: {
      3: 10,
      5: 20,
      7: 30
    },
    timeStreakBonusMap: {
      3: 2,
      5: 4,
      7: 6
    },
    continuousScoreBonus: true,
    continuousTimeBonus: false,
    timePenalty: 1
  },
  audio: {
    success: trueSound,
    error: falseSound,
    volume: 0.7,
    enabled: true
  },
  languages: {
    set1: { q: 'en-US', a: 'uk-UA' },
    set2: { q: 'uk-UA', a: 'en-US' }
  }
};
